import React from "react";

const paths = {
  savings: <><path d="M4 9h16v10H4z"/><path d="M7 9V6h10v3M8 14h8M12 11v6"/></>,
  installments: <><rect x="5" y="3" width="14" height="18" rx="3"/><path d="M8 8h8M8 12h5M8 16h7"/></>,
  subscriptions: <><path d="M7 7h9l-2-2M17 17H8l2 2"/><path d="M18 8a7 7 0 0 1 1 4M6 16a7 7 0 0 1-1-4"/></>,
  bills: <><path d="M6 3h12v18l-3-2-3 2-3-2-3 2V3Z"/><path d="M9 8h6M9 12h6M9 16h4"/></>,
  birthday: <><path d="M4 11h16v9H4zM7 11V8h10v3"/><path d="M12 8V5M10.5 4.5 12 2l1.5 2.5"/></>,
  blood: <path d="M12 2s6 7 6 12a6 6 0 0 1-12 0c0-5 6-12 6-12Z"/>,
  member: <><circle cx="9" cy="8" r="3"/><circle cx="17" cy="9" r="2"/><path d="M3 20c.5-4 2.5-6 6-6s5.5 2 6 6M14 15c3-.2 5 1.4 6 4"/></>,
  growth: <><path d="M4 19 10 13l4 3 6-9"/><path d="M15 7h5v5"/></>,
  health: <path d="M12 20S4 15 4 9a4 4 0 0 1 7-2.5L12 8l1-1.5A4 4 0 0 1 20 9c0 6-8 11-8 11Z"/>,
  education: <><path d="m3 9 9-5 9 5-9 5-9-5Z"/><path d="M7 12v5c3 2 7 2 10 0v-5"/></>,
  routine: <path d="M19 15.5A8 8 0 0 1 8.5 5 8 8 0 1 0 19 15.5Z"/>,
  nutrition: <><path d="M5 11h14a7 7 0 0 1-14 0Z"/><path d="M9 4c0 2 2 2 2 4M14 3c0 2-2 3-1 5"/></>,
  memory: <><rect x="3" y="6" width="18" height="13" rx="3"/><circle cx="12" cy="12.5" r="3.5"/><path d="m8 6 1-2h6l1 2"/></>,
  diaper: <><path d="M5 7c2 2 4 3 7 3s5-1 7-3v8c-2 4-12 4-14 0V7Z"/><path d="M8 11v4M16 11v4"/></>,
  care: <><path d="M8 20h8M10 20v-8h4v8M9 12h6l-1-6h-4l-1 6Z"/><path d="M12 3v3"/></>,
  pages: <><rect x="4" y="3" width="16" height="18" rx="3"/><path d="M8 8h8M8 12h8M8 16h5"/></>,
  actions: <path d="m13 2-9 12h7l-1 8 10-13h-7V2Z"/>,
  profile: <><circle cx="12" cy="8" r="4"/><path d="M4 21c.7-5 3.3-7 8-7s7.3 2 8 7"/></>,
  password: <><circle cx="8" cy="12" r="4"/><path d="m12 12 8-8M17 7l3 3M15 9l2 2"/></>,
  mail: <><rect x="3" y="5" width="18" height="14" rx="3"/><path d="m4 7 8 6 8-6"/></>,
  custom: <><path d="M4 20h4l11-11-4-4L4 16v4Z"/><path d="m13 7 4 4"/></>,
  fullAccess: <path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9L12 3Z"/>,
  standard: <><circle cx="9" cy="8" r="3"/><path d="M3 20c.5-4 2.5-6 6-6s5.5 2 6 6M16 8h5M18.5 5.5v5"/></>,
  childProfile: <><circle cx="12" cy="9" r="5"/><path d="M8 8c2 1 6 1 8 0M9.5 11h.01M14.5 11h.01M5 21c.6-4 3-6 7-6s6.4 2 7 6"/></>,
  viewOnly: <><path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></>,
  read: <path d="M4 12.5 9 17l11-11"/>,
  pending: <><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></>,
  repeat: <><path d="M7 7h10l-2-2M17 17H7l2 2"/><path d="M19 8a7 7 0 0 1 1 4M5 16a7 7 0 0 1-1-4"/></>,
  refresh: <><path d="M20 7v5h-5M4 17v-5h5"/><path d="M18 12a6 6 0 0 0-10-4L4 12M6 12a6 6 0 0 0 10 4l4-4"/></>,
};

export default function AppFeatureIcon({ type, className = "" }) {
  return <span className={`appFeatureIcon appFeatureIcon--${type} ${className}`} aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">{paths[type] || paths.memory}</svg></span>;
}
